(function(){
  var KEY='irdoja_signup';
  var root=document.getElementById('ir-signup'); if(!root) return;
  var company=root.dataset.company, list=root.dataset.list;
  var API='https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(company);
  function state(){ try{ return JSON.parse(localStorage.getItem(KEY)||'{}'); }catch(e){ return {}; } }
  function save(s){ try{ localStorage.setItem(KEY,JSON.stringify(s)); }catch(e){} }
  function subscribe(email,source){
    var body={data:{type:'subscription',attributes:{custom_source:source,profile:{data:{type:'profile',attributes:{email:email}}}},relationships:{list:{data:{type:'list',id:list}}}}};
    return fetch(API,{method:'POST',keepalive:true,headers:{'Content-Type':'application/vnd.api+json','revision':'2024-10-15'},body:JSON.stringify(body)})
      .then(function(r){ if(r.status===202||r.ok) return true; return r.json().then(function(j){ throw new Error((j.errors&&j.errors[0]&&j.errors[0].detail)||'Could not subscribe'); }); });
  }
  var valid=function(e){ return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e); };

  /* --- enhance any Shopify newsletter form on the page so it also reaches Klaviyo ---
     Irdoja 2026-09-23: this path was list-bombed. Six bot submissions between 09-18 and 09-23,
     every one an address belonging to a stranger (a university, a brokerage, a charity inbox),
     from anonymising IPs including Tor exits, all reporting the same spoofed browser string, and
     none of them ever loaded a page. The popup was never abused because it carries a honeypot.
     Three gates here now: a honeypot field, a real (trusted) submit, and a minimum time on page.
     NOTE: a bot that posts straight to Klaviyo's public client endpoint skips all of this, because
     company id and list id are necessarily public in the page. Double opt-in on the list is the
     only control for that case. */
  var IRS_LOADED=Date.now();
  document.querySelectorAll('form').forEach(function(f){
    var inp=f.querySelector('input[type="email"][name="contact[email]"]'); if(!inp) return;
    var hp=document.createElement('input');
    hp.type='text'; hp.name='irdoja_company'; hp.tabIndex=-1; hp.value=''; hp.autocomplete='off';
    hp.setAttribute('aria-hidden','true');
    hp.style.cssText='position:absolute!important;left:-9999px!important;top:auto;width:1px;height:1px;opacity:0;pointer-events:none';
    f.appendChild(hp);
    f.addEventListener('submit',function(e){
      if(hp.value) return;                                   /* honeypot filled: a bot */
      if(e && e.isTrusted===false) return;                   /* submit fired by a script */
      if(Date.now()-IRS_LOADED<3000) return;                 /* faster than a person can type */
      var v=(inp.value||'').trim(); if(!valid(v)) return;
      subscribe(v,'Website newsletter').then(function(){ var s=state(); s.subscribed=Date.now(); save(s); }).catch(function(){});
    });
  });

  /* --- popup --- */
  var s=state(), now=Date.now(), days=parseInt(root.dataset.days||'14',10)*864e5;
  var excluded=(root.dataset.exclude||'').split(',').map(function(x){return x.trim();}).filter(Boolean);
  var tpl=root.dataset.template||'', path=root.dataset.handle||location.pathname;
  if(/nopopup/.test(location.search)) return;
  if(s.subscribed) return;
  if(s.dismissed && now-s.dismissed<days) return;
  if(excluded.some(function(t){ return tpl===t || tpl.indexOf(t)===0; })) return;
  if(/\/(cart|checkout|account|pages\/contact|pages\/appointment-confirmed)/.test(path)) return;
  if(window.Shopify && Shopify.designMode) return;

  var shown=false, lastFocus=null;
  var card=root.querySelector('.isu__card'), form=root.querySelector('.isu__form'), err=root.querySelector('.isu__err');
  function open(){ if(shown) return; shown=true; root.hidden=false; root.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden'; lastFocus=document.activeElement; setTimeout(function(){ var i=root.querySelector('#isu-email'); i&&i.focus({preventScroll:true}); },60); }
  function close(){ root.hidden=true; root.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; var st=state(); if(!st.subscribed) st.dismissed=Date.now(); save(st); if(lastFocus&&lastFocus.focus) lastFocus.focus(); }
  root.querySelectorAll('[data-irs-close]').forEach(function(b){ b.addEventListener('click',close); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!root.hidden) close(); });

  var delay=parseInt(root.dataset.delay||'9',10)*1000, pct=parseInt(root.dataset.scroll||'35',10);
  var timer=setTimeout(open,delay);
  function onScroll(){ var h=document.documentElement; var p=(h.scrollTop)/(h.scrollHeight-h.clientHeight||1)*100; if(p>=pct){ open(); window.removeEventListener('scroll',onScroll); } }
  window.addEventListener('scroll',onScroll,{passive:true});
  if(root.dataset.exit==='true' && matchMedia('(pointer:fine)').matches){ document.addEventListener('mouseout',function(e){ if(!e.relatedTarget && e.clientY<=0) open(); }); }

  form.addEventListener('submit',function(e){
    e.preventDefault(); err.hidden=true;
    if(form.website && form.website.value) return; /* honeypot */
    var v=(form.email.value||'').trim(); if(!valid(v)){ err.textContent='That email does not look right.'; err.hidden=false; form.email.focus(); return; }
    var btn=form.querySelector('.isu__btn'); btn.disabled=true;
    subscribe(v,'Popup').then(function(){
      var st=state(); st.subscribed=Date.now(); save(st);
      root.querySelector('.isu__form-wrap').hidden=true; root.querySelector('.isu__done').hidden=false;
      if(window.klaviyo && klaviyo.identify){ try{ klaviyo.identify({email:v}); }catch(x){} }
      if(window.dataLayer){ dataLayer.push({event:'newsletter_signup',method:'popup'}); }
    }).catch(function(ex){ btn.disabled=false; err.textContent=ex.message||'Something went wrong. Please try again.'; err.hidden=false; });
  });
})();
